import { render, staticRenderFns } from "./AccountContextSuggestDialog.vue?vue&type=template&id=a2ca3dd6&scoped=true"
import script from "./AccountContextSuggestDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountContextSuggestDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountContextSuggestDialog.vue?vue&type=style&index=0&id=a2ca3dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ca3dd6",
  null
  
)

export default component.exports